// FeedbackSection.tsx
import { BaseText, Button } from 'aimo-ui';
import { t } from 'i18next';
import React from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { testIdentifiers } from 'utils/testIdentifiers';

const styles = StyleSheet.create({
  feedbackInputSection: {
    width: '100%',
    alignItems: 'center',
    paddingVertical: 20,
    paddingHorizontal: 40,
  },
  input: {
    width: '100%',
    padding: 10,
    borderWidth: 1,
    borderColor: '#CCC',
    borderRadius: 8,
    marginVertical: 15,
    backgroundColor: '#FFF',
    minHeight: 70,
    color: 'black',
    maxWidth: 600,
  },
});

const FeedbackInputSection: React.FC<{
  title: string;
  description?: string;
  buttonText: string;
  onButtonPress: () => void;
  feedbackMessage?: string;
  setFeedbackMessage?: (text: string) => void;
}> = ({
  title,
  description,
  buttonText,
  onButtonPress,
  feedbackMessage,
  setFeedbackMessage,
}) => (
  <View style={styles.feedbackInputSection}>
    <StyledWrapper center maxWidth={250} mb={5}>
      <BaseText center>{title}</BaseText>
      {description && <BaseText center>{description}</BaseText>}
    </StyledWrapper>
    {feedbackMessage !== undefined && setFeedbackMessage !== undefined && (
      <TextInput
        {...testIdentifiers(`feedback-input`)}
        style={styles.input}
        placeholder={t('feedback.inputPlaceholder')}
        value={feedbackMessage || ''}
        onChangeText={setFeedbackMessage}
        placeholderTextColor="#888"
        multiline
      />
    )}
    <StyledWrapper mb={2} center maxWidth={300}>
      <Button
        size="l"
        buttonType="primary"
        {...testIdentifiers(`feedback-submit-button`)}
        onPress={onButtonPress}
        text={buttonText}
      />
    </StyledWrapper>
  </View>
);

export default FeedbackInputSection;
